import React from 'react';
import Image from '@ecs/tng-common/components/image/Image';
import {
  CollapseECS,
  CollapseECSBody,
  CollapseECSButton
} from '@ecs/tng-common/components/collapse/CollapseEcs';
import { sharedAssetsPath } from '@ecs/tng-common/scripts/data';
import {
  atmDisclosure,
  bonusDisclosure,
  cardholderAgreement,
  checkingAccountFDIC,
  limitsApply,
  scoreBoostResultsFull,
  smBanking
} from '@ecs/tng-common/documents/disclosures/regulatory';
import {
  DisclosuresWrapper,
  DisclosureSymbolLink
} from '@ecs/tng-common/components/disclosures/Disclosures';

interface CustomEsmWidgetProps {
  isSEMtemplate: boolean;
}
export default class CustomEsmWidget extends React.Component<CustomEsmWidgetProps> {
  render() {
    const smDisclosuresPage = '/help/experian-smart-money/?cc=van_reg_legal';
    return (
      <div
        id="expsm"
        className="mb-4 mb-md-5">
        <div className="">
          {!this.props.isSEMtemplate && (
            <p className="bg-midnight-blue text-white text-uppercase py-2 px-4 h7 mb-0">
              Featured Account
            </p>
          )}
          <div className="d-flex flex-wrap p-4 bg-white border justify-content-between">
            <div className="logo-col">
              <a
                href="/money/experian-smart-money/"
                target="_blank"
                data-link-both="esm-cta-viewdetails-image">
                <Image
                  src={`${sharedAssetsPath}/logos/logo-experian.svg`}
                  alt="Experian Logo."
                  width="120"
                  height="120"
                  className="img-fluid w-100"
                  lazyLoading
                />
              </a>
            </div>
            <div className="adcopy-col">
              <a
                href="/money/experian-smart-money/"
                target="_blank"
                className="text-decoration-none fw-bold"
                data-link-both="esm-cta-viewdetails-title">
                Experian Smart Money™ Digital Checking Account & Debit Card
              </a>
              <div className="prop-container-wrapper d-flex justify-content-between pt-4">
                <div className="prop-container">
                  <p className="h7">BONUS</p>
                  <p className="body-text-sm">
                    $50 with qualifying direct deposits
                    <DisclosureSymbolLink
                      disclosure={bonusDisclosure}
                      disclosureLink={`${smDisclosuresPage}#${bonusDisclosure.id}`}
                      id=""
                    />
                  </p>
                </div>
                <div className="prop-container">
                  <p className="h7">MONTHLY FEE</p>
                  <p className="body-text-sm">$0</p>
                </div>
                <div className="prop-container">
                  <p className="h7">MIN OPENING DEPOSIT</p>
                  <p className="body-text-sm">$0</p>
                </div>
              </div>
            </div>
            <div className="cta-col text-center">
              <a
                href="/money/experian-smart-money/"
                target="_blank"
                data-link-both="esm-cta-viewdetails-link"
                className="btn btn-secondary px-0 py-2 w-100 fw-bold mb-4">
                VIEW DETAILS
              </a>
              <div className="d-flex fdiclogo-wrapper justify-content-center">
                <span className="fdiclogo" />
                <small className="fw-bold">FDIC Insured</small>
              </div>
              <a
                href={smDisclosuresPage}
                target="_blank"
                className="fw-bold body-text-xs"
                data-link-both="esm-link-productdisclosures">
                Product Disclosure
              </a>
            </div>
            <div className="seemoreless w-100">
              <CollapseECS id="see-more">
                <div className="d-flex mob-wrapper">
                  <div className="d-flex fdiclogo-wrapper">
                    <span className="fdiclogo" />
                    <small className="fw-bold">FDIC Insured</small>
                  </div>
                  <CollapseECSButton className="btn-reset  fw-bold body-text-xs text-secondary see-more">
                    <span className="collapse-closed-control align-items-center">
                      <span className="text-decoration-underline">See More</span>
                      <span className="ecs-font-icon-nav-angle-down font-icon-size-md" />
                    </span>
                    <span className="collapse-open-control align-items-center">
                      <span className="text-decoration-underline">See Less</span>
                      <span className="ecs-font-icon-nav-angle-up font-icon-size-md" />
                    </span>
                  </CollapseECSButton>
                </div>
                <CollapseECSBody>
                  <div className="bg-coconut p-3 p-md-4">
                    <p className="h7">ADDITIONAL FEATURES</p>

                    <ul className="desc-content">
                      <li>
                        Build credit by paying bills like utilities, streaming services and rent
                        <DisclosureSymbolLink
                          disclosure={scoreBoostResultsFull}
                          disclosureLink={`${smDisclosuresPage}#${scoreBoostResultsFull.id}`}
                          id=""
                        />
                      </li>
                      <li>
                        $50 bonus with direct deposit
                        <DisclosureSymbolLink
                          disclosure={bonusDisclosure}
                          disclosureLink={`${smDisclosuresPage}#${bonusDisclosure.id}`}
                          id=""
                        />
                      </li>
                      <li>
                        No monthly fees, no minimums
                        <DisclosureSymbolLink
                          disclosure={bonusDisclosure}
                          disclosureLink={`${smDisclosuresPage}#${cardholderAgreement.id}`}
                          id=""
                        />
                      </li>
                      <li>
                        Secure & FDIC insured up to $250,000
                        <DisclosureSymbolLink
                          disclosure={checkingAccountFDIC}
                          disclosureLink={`${smDisclosuresPage}#${checkingAccountFDIC.id}`}
                          id=""
                        />
                      </li>
                      <li>
                        Zero liability for fraudulent purchases
                        <DisclosureSymbolLink
                          disclosure={cardholderAgreement}
                          disclosureLink={`${smDisclosuresPage}#${cardholderAgreement.id}`}
                          id=""
                        />
                      </li>
                      <li>
                        55,000+ no-fee ATMs worldwide
                        <DisclosureSymbolLink
                          disclosure={atmDisclosure}
                          toSuperscriptSymbol={false}
                          disclosureLink={`${smDisclosuresPage}#${atmDisclosure.id}`}
                          id=""
                        />
                      </li>
                      <li>
                        Deposit cash at popular retailers
                        <DisclosureSymbolLink
                          disclosure={limitsApply}
                          disclosureLink={`${smDisclosuresPage}#${limitsApply.id}`}
                          id=""
                        />
                      </li>
                      <li>Live customer support 7 days a week</li>
                    </ul>
                    <DisclosuresWrapper>
                      <p>{smBanking}</p>
                    </DisclosuresWrapper>
                  </div>
                </CollapseECSBody>
              </CollapseECS>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
